/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { styled } from "styled-components";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Pagination from "../Pagination/index";

const MainContainer = styled.div`
  // width: 100%;
  // padding: 0 100px;
  padding: 0 100px 60px 100px;
`;

function TableData({ data, tableData, headers, onPageChange }) {
  const [currentPage, setCurrentPage] = useState(0);

  const handleChangePage = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
    onPageChange(selectedPage.selected);
  };

  const pageCount = data.totalPages;

  return (
    <MainContainer>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow
              style={{
                background:
                  "linear-gradient(180deg, #2A93C1 0%, #1D7196 87.50%, #BCD4DE 100%)",
              }}
            >
              {headers.map((header) => (
                <TableCell
                  key={header}
                  sx={{
                    fontWeight: "bold",
                    color: "white",
                    padding: "10px",
                    textAlign: "center",
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((row, index) => (
              <TableRow
                key={row.id}
                sx={{ background: index % 2 === 1 ? "#E8F6FC" : "#ffffff" }}
              >
                <TableCell
                  sx={{
                    width: "10%",
                    borderBottom:
                      index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
                    borderTop: index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
                    textAlign: "center",
                  }}
                >
                  {row.column1}
                </TableCell>
                <TableCell
                  sx={{
                    borderBottom:
                      index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
                    borderTop: index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
                    textAlign: "center",
                  }}
                >
                  {row.column2}
                </TableCell>
                <TableCell
                  sx={{
                    width: "20%",
                    borderBottom:
                      index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
                    borderTop: index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
                    textAlign: "center",
                  }}
                >
                  {row.column3}
                </TableCell>
                {/* <TableCell sx={{ borderRight: '2px solid #000000',}}>
                  {row.column4}
                </TableCell> */}
                {row.column4 && (
                  <TableCell
                    sx={{
                      borderBottom:
                        index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
                      borderTop:
                        index % 2 === 1 ? "1px solid #62B6DA" : "#ffff",
                      textAlign: "center",
                    }}
                  >
                    {row.column4}
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        pageCount={pageCount}
        onPageChange={handleChangePage}
        forcePage={currentPage}
      />
    </MainContainer>
  );
}

export default TableData;
